import { useEffect, useState } from "react";
import { _AdquisitionItem, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../theme/Component/BasicPage"
import { BasicTable, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { Modal } from "../../theme/Component/Modal";
import { SelectAdquisitionPlan } from "../select/SelectAdquisitionPlan";
import { SelectAdquisitionPlanFunctionalID } from "../select/SelectAdquisitionPlanFunctionalID";
import { PlanAnualdeCuentas } from "./PlanAnualdeCuentas";
import usePaginator from "../../theme/Component/usePaginator";
import { SelectAdquisitionPlanFunctionalIDByPlan } from "../select/SelectAdquisitionPlanFunctionalIDByPlan";

export const AdquisitionItemPAC = () => {

    const _service = useDataBean(_AdquisitionItem);
    const { instance, lista, setLista, bean, setBean } = _service;
    const modalEdit = useModal("Editar", MODAL_LG);
    const [idPlan, setIDPlan] = useState<number>(0);
    const [idArea, setIDArea] = useState<number>(0);
    const [props,setProps] = useState<any>({});
    const paginador = usePaginator();

    useEffect(() => {
        getAdquisitionItemByProps();
    }, [paginador.page,props.IDAdquisitionPlanFunctionalID])

    const getAdquisitionItemByProps = () => {

        let data = {};

        instance.getAdquisitionItemByProps(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                setLista(resp.List);
            }
        ).catch(err => toast.warning(err));
    }

    const head = [
        { title: 'ID', property: 'IDAdquisitionItem', visible: true, mask: MASK_NUMBER },
        { title: 'Mes Contrato', property: 'MonthName', visible: true },
        { title: 'Objecto', property: 'Description', visible: true },
        { title: 'Area', property: 'IDLnFunctionalIDName', visible: true },
        { title: 'Rubros', property: 'IDLnBudgetIDNameList', visible: true },
        { title: 'Estado', property: 'PreparationStateName', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            // {titulo:'Agregar',icono:'ri-file-add-line',visible:true,evento:agregarItem},
            { titulo: 'Plan Anual de Cuentas', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Necesidades">
            <div className="row">
                <div className="col-md-6">
                    <SelectAdquisitionPlan _year={_single.getCurrenYear()} idSelector={idPlan} onChange={(e) => { setIDPlan(parseInt(e)) }} />
                </div>
                <div className="col-md-6">
                    <SelectAdquisitionPlanFunctionalIDByPlan _idPlan={idPlan} idSelector={props.IDAdquisitionPlanFunctionalID} 
                    onChange={(e) => { setProps({...props,"IDAdquisitionPlanFunctionalID":e})}} />

                </div>
                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}></BasicTable>
                    <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal}>
                        <div className="row">
                            <div className="col">
                                <PlanAnualdeCuentas IDAdquisitionItem={_service.bean.IDAdquisitionItem} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}